import axios from "../../../apis/Api";
import history, { logout } from "../../../history";
import { toast } from "react-toastify";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import { GET_BAFL_KYC_REPORT } from "../../../Types";
import fileSaver from "file-saver";
import * as XLSX from "xlsx";

export const getBaflKycReport = (requestData) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post(`api/LendingReports/GetBaflKycReport`, requestData)
    .then(({ data }) => {
      debugger;
      if (data)
        dispatch({
          type: GET_BAFL_KYC_REPORT,
          payload: data,
        });
      dispatch(hideLoading());
    })
    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      }
    });
};

export const downloadJob = (requestData) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post(`api/LendingReports/GetBaflKycReport`, requestData)
    .then(({ data }) => {
      const outputFilename = `BAFL_KYC_Report_${Date.now()}`;
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";

      const exportToCSV = (csvData, jobNumber, fileName) => {
        const ws = XLSX.utils.json_to_sheet(csvData);
        if (ws) {
          var range = XLSX.utils.decode_range(ws["!ref"]);
          for (var C = range.s.c; C <= range.e.c; ++C) {
            var address = XLSX.utils.encode_col(C) + "1"; // <-- first row, column number C
            if (!ws[address]) continue;
                      ws[address].v =
                      ws[address].v == "distributor"
                        ? "Distributor"
                        : ws[address].v == "distCenter"
                        ? "Dist Center"
                        : ws[address].v == "vizId"
                        ? "VIZ ID"
                        : ws[address].v == "shopCode"
                        ? "Shop Code"
                        : ws[address].v == "shopName"
                        ? "Shop Name"
                        // Personal Info
                        : ws[address].v == "fullName"
                        ? "Full Name"
                        : ws[address].v == "cnicNo"
                        ? "CNIC No"
                        : ws[address].v == "cnicIssuanceDate"
                        ? "CNIC Issuance Date"
                        : ws[address].v == "fatherOrSpouseName"
                        ? "Father / Spouse Name"
                        : ws[address].v == "city"
                        ? "City"
                        : ws[address].v == "gender"
                        ? "Gender"
                        : ws[address].v == "maritalStatus"
                        ? "Marital Status"
                        : ws[address].v == "dateOfBirth"
                        ? "Date of Birth"
                        : ws[address].v == "qualification"
                        ? "Qualification"
                        // Contact Info
                        : ws[address].v == "mobileNumber"
                        ? "Mobile Number"
                        : ws[address].v == "email"
                        ? "Email"
                        : ws[address].v == "residentialAddress"
                        ? "Residential Address"
                        // Business Info
                        : ws[address].v == "businessName"
                        ? "Business Name"
                        : ws[address].v == "businessType"
                        ? "Business Type"
                        : ws[address].v == "businessAddress"
                        ? "Business Address"
                        : ws[address].v == "ownershipStatus"
                        ? "Ownership Status"
                        // Financial Info
                        : ws[address].v == "annualRevenue"
                        ? "Annual Revenue"
                        : ws[address].v == "costOfGoodsSold"
                        ? "Cost of Goods Sold"
                        : ws[address].v == "otherOperatingExpenses"
                        ? "Other Operating Expenses"
                        : ws[address].v == "netIncome"
                        ? "Net Income"
                        : ws[address].v == "currentAssets"
                        ? "Current Assets"
                        : ws[address].v == "fixedAssets"
                        ? "Fixed Assets"
                        : ws[address].v == "valuationOfStore"
                        ? "Valuation of Store"
                        : ws[address].v == "numberOfEmployees"
                        ? "Number of Employees"
                        : ws[address].v == "ntn"
                        ? "NTN"
                        : ws[address].v == "totalLiabilities"
                        ? "Total Liabilities"
                        // Financing Info
                        : ws[address].v == "purposeOfFinancing"
                        ? "Purpose of Financing"
                        : ws[address].v == "amountOfFinancing"
                        ? "Amount of Financing"
                        : ws[address].v == "availOtherFinancingProduct"
                        ? "Avail Other Financing Product"
                        : ws[address].v == "notAvailFinancingProduct"
                        ? "Not Avail Financing Product"
                        : ws[address].v == "bankName"
                        ? "Bank Name"
                        : ws[address].v == "facilityType"
                        ? "Facility Type"
                        : ws[address].v == "facilityLimit"
                        ? "Facility Limit"
                        : ws[address].v == "installmentAmount"
                        ? "Installment Amount"
                        // Status Info
                        : ws[address].v == "whitelistingStatus"
                        ? "Whitelisting Status"
                        : ws[address].v == "kycStatus"
                        ? "KYC Status"
                        : ws[address].v == "contractStatus"
                        ? "Contract Status"
                        : ws[address].v == "agreementSigned"
                        ? "Agreement Signed"
                        : ws[address].v == "signedDate"
                        ? "Signed Date"
                        : ws[address].v == "financier"
                        ? "Financier"
                        // Limit Info
                        : ws[address].v == "assignedLimit"
                        ? "Assigned Limit"
                        : ws[address].v == "usedLimit"
                        ? "Used Limit"
                        : ws[address].v == "balance"
                        ? "Balance"
                        : ws[address].v == "assignLimit"
                        ? "Assign Limit"
                        // Misc
                        : ws[address].v == "date"
                        ? "Date"
                        : ws[address].v == "reason"
                        ? "Reason"
                        : ws[address].v == "externalId"
                        ? "External ID"
                        : ws[address].v == "creditRequired"
                        ? "Credit Required"
                        : ws[address].v;

          }
        }
        // var sheetName = `Job_Number_${jobNumber}`
        const wb = {
          Sheets: { data: ws },
          SheetNames: [`data`],
        };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const fileData = new Blob([excelBuffer], { type: fileType });
        fileSaver.saveAs(fileData, fileName + fileExtension);
      };
      exportToCSV(data?.report, "", outputFilename);
      dispatch(hideLoading());
    })

    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      }
    });
};
